import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { TableColumnService } from './types/table-column-service.interface';
import { TableColumnServiceImpl } from './table-column-service';
export const tableColumn = new ContainerModule((bind) => {
    bind(TableColumnService).to(TableColumnServiceImpl);
});
